const SCAN_DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
});

const SHORT_SCAN_DATE_FORMAT = new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric'
});

// Date-only values parse as UTC midnight and render as the previous day in
// negative-offset timezones, so build them as local dates instead.
export function parseScanDate(value: string): Date | null {
    if (!value) return null;
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    const date = dateOnly
        ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
        : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function formatScanDate(value: string): string {
    const date = parseScanDate(value);
    return date ? SCAN_DATE_FORMAT.format(date) : value;
}

export function formatShortScanDate(value: string): string {
    const date = parseScanDate(value);
    return date ? SHORT_SCAN_DATE_FORMAT.format(date) : value;
}
